import { lazy } from 'react';

const PreviewImageModal = lazy(
  () =>
    import('modules/Opportunities/modals/PreviewImageModal/PreviewImageModal'),
);

export default {
  OPPORTUNITY_PREVIEW_IMAGE_MODAL: PreviewImageModal,
};
